module.exports = __webpack_public_path__ + "img/certificate_bottom_chinese_text.61c7a6fc.svg";